import type { paths } from '@pba/types-openapi-node';
import type { BodyRouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type NodeEventFeedbackBodyRequestParams =
  paths['/events/{eventId}/participants/{participantId}/feedback']['post']['requestBody']['content']['application/json'];
type NodeEventFeedbackPathRequestParams =
  paths['/events/{eventId}/participants/{participantId}/feedback']['post']['parameters']['path'];

export const createNodeEventFeedback = async ({
  body,
  routeParams: { eventId, participantId },
}: BodyRouteParamsRequest<NodeEventFeedbackBodyRequestParams, NodeEventFeedbackPathRequestParams>) =>
  nodeApiClient.post<undefined, ApiClientResponse<undefined>>(
    nodeApiRoutes.events.participants.feedback(eventId, participantId),
    body,
  );
